// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'archive';

export const Component = () => (
  <path d='M23.031 5.784v-.048l-4.262-3.4a1.346 1.346 0 0 0-.91-.336H6.748c-.336 0-.623.096-.91.335l-4.263 3.4c-.383.336-.575.72-.575 1.15v14.272c0 .431.144.766.431 1.054.288.287.623.431 1.054.431 2.395-.047 8.956-.047 19.636-.047.431 0 .767-.144 1.006-.432.335-.239.478-.575.478-1.005V6.886c0-.431-.19-.814-.575-1.102h.001Zm-10.248.143v-2.92h5.076c.048 0 .144.047.288.095l3.544 2.826h-8.908Zm-9.867 0L6.46 3.102c.144-.048.24-.097.288-.097h5.076v2.922H2.916Zm19.685 1.006v14.224c0 .144-.048.24-.144.335a.434.434 0 0 1-.335.144H2.486a.434.434 0 0 1-.335-.144.434.434 0 0 1-.144-.335V6.933h9.818v3.448c0 .335.144.48.479.48.335 0 .479-.145.479-.48V6.933H22.6Z' />
);

export const viewBox = '0 0 25 25';
